import { ActionButton } from './action-button';

/**
 * A surface whose data did not load, said inside the page rather than as
 * zeroes. The overview showed "0 active clients" and "Loading clients…"
 * forever when the API failed — a coach reads that as an empty roster.
 */
export const LoadErrorCard: React.FC<{
  title: string;
  message: string;
  /** e.g. "Error 500", in small muted type for support. */
  detail?: string;
  onRetry: () => void;
  retrying?: boolean;
  testId?: string;
}> = ({ title, message, detail, onRetry, retrying, testId }) => (
  <div
    role="alert"
    data-testid={testId}
    className="flex flex-col items-start gap-2 rounded-lg border border-border bg-card p-5"
  >
    <h2 className="text-[15px] font-semibold tracking-tight">{title}</h2>
    <p className="max-w-[60ch] text-[12.5px] leading-relaxed text-foreground-soft">{message}</p>
    {detail && <p className="tabular text-[10.5px] text-muted-foreground">{detail}</p>}
    <ActionButton
      variant="primary"
      className="mt-2"
      onClick={onRetry}
      disabled={retrying}
      testId={testId ? `${testId}-retry` : undefined}
    >
      {retrying ? 'Trying again…' : 'Try again'}
    </ActionButton>
  </div>
);
